import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Runs after authentication, including cookie refresh and website handoff.
export const homeGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = auth.getCurrentUser();
  return (user ? of(user) : auth.me()).pipe(
    map(() => {
      const destination = auth.landingUrl(state.url);
      return destination === state.url ? true : router.parseUrl(destination);
    }),
    catchError(() => of(router.createUrlTree(['/welcome']))),
  );
};
